import { customAlphabet } from 'nanoid';

const getIds = (num) => {
    const nanoid = customAlphabet('qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM0123456789', 6);
    const ids = [];

    const handleIds = () => {
        const id = nanoid();
        if (ids.includes(id)) {
            return handleIds();
        };

        return id;
    };
    for (let i = 0; i < num; i++) {
        ids.push(handleIds(0));
    };
    return ids;
};

const serviceLog = () => {
    const ids = getIds(4);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    },{
        id: ids[0],
        name: 'My Service Log',
        type: 'G7kP',
        archived: false,
        options: [],
        required: false
    },{
        id: ids[1],
        name: 'Name',
        type: 'flqW',
        archived: false,
        options: [],
        required: true
    },{
        id: ids[2],
        name: 'Location',
        type: 'flqW',
        archived: false,
        options: [],
        required: true
    },{
        id: ids[3],
        name: 'Notes',
        type: 'fLZw',
        archived: false,
        options: [],
        required: false
    }];
};

const workoutLog = () => {
    const ids = getIds(3);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[0],
        name: 'My Workout Log',
        type: 'G7kP',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[1],
        name: 'Areas Focused:',
        type: 't9wW',
        archived: false,
        options: ['Endurance','Strength','Balance','Flexibility','None'],
        required: true
    }, {
        id: ids[2],
        name: 'Exercises Completed:',
        type: 't9wW',
        archived: false,
        options: ['Cardio (walking, running, biking, swimming, elipitical)','Upper Body (bench press, overhead, pull-ups, curls, push-ups)','Lower Body (squats, deadlift, calf raises)','Core (crunches, plank)','Arms (bicep curls, wrist curls, tricep extensions)','Classes or Guided Workouts (yoga, zumba, pilates, jazzercise)','None'],
        required: true
    }];
};

const vehicleLog = () => {
    const ids = getIds(3);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[0],
        name: 'My Vehicle Log',
        type: 'G7kP',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[1],
        name: 'Service Received',
        type: 't9wW',
        archived: false,
        options: ['Filled Gas','Oil Change','Tire Rotation/Balance','Other'],
        required: true
    }, {
        id: ids[2],
        name: 'Notes from Service',
        type: 'fLZw',
        archived: false,
        options: [],
        required: false
    }];
};

const maintenanceTracker = () => {
    const ids = getIds(5);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[0],
        name: 'My Maintenance Tracker',
        type: 'G7kP',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[1],
        name: 'Location of Maintenance',
        type: 'flqW',
        archived: false,
        options: [],
        required: true
    }, {
        id: ids[2],
        name: 'Equipment tested/fixed/maintained',
        type: 'flqW',
        archived: false,
        options: [],
        required: true
    },{
        id: ids[3],
        name: 'Next steps if any',
        type: 'fLZw',
        archived: false,
        options: [],
        required: false
    },{
        id: ids[4],
        name: 'Notes',
        type: 'fLZw',
        archived: false,
        options: [],
        required: false
    }];
};

const bugReport = () => {
    const ids = getIds(4);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[0],
        name: 'My Bug Report',
        type: 'G7kP',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[1],
        name: 'Location or page where the bug occurred',
        type: 'YiOY',
        archived: false,
        options: [],
        required: true
    }, {
        id: ids[2],
        name: 'Is this a breaking bug?',
        type: 'JScO',
        archived: false,
        options: ['Yes','No','Not Sure'],
        required: true
    },{
        id: ids[3],
        name: 'Describe steps to recreate the bug',
        type: 'GDNV',
        archived: false,
        options: [],
        required: false
    }];
};

const review = () => {
    const ids = getIds(3);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[0],
        name: 'My Review',
        type: 'G7kP',
        archived: false,
        options: [],
        required: false
    }, {
        archived: false,
        icon: 'stars',
        id: ids[1],
        name: 'Rate your experience 1 to 5, 1 being worst 5 being best',
        options: [],
        required: true,
        type: 'Z39Z'
    }, {
        id: ids[2],
        name: 'What, if anything, would you like to see changed on your next visit?',
        type: 'GDNV',
        archived: false,
        options: [],
        required: false
    }];
};

const gardenLabel = () => {
    const ids = getIds(13);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[0],
        name: 'Plant Care Log',
        type: 'G7kP',
        archived: false,
        options: [],
        required: false
    }, {
        archived: false,
        id: ids[1],
        name: 'Use this form each time you check on this plant. Logging care consistently helps track watering, fertilizing, health issues, and overall growth.',
        options: [],
        required: false,
        type: 'q1AZ'
    }, {
        id: ids[2],
        name: 'Plant Health Today',
        type: 'mU8a',
        archived: false,
        options: [],
        required: false,
        scale: 5
    }, {
        id: ids[3],
        name: 'Growth Progress',
        type: 'Z39Z',
        archived: false,
        options: [],
        required: false,
    },{
        id: ids[4],
        name: 'Watered Today',
        type: 'Q44D',
        archived: false,
        options: [],
        required: false,
    },{
        id: ids[5],
        name: 'Watered Amount',
        type: 'jDSq',
        archived: false,
        options: ["Light","Moderate","Heavy"],
        required: false,
    },{
        id: ids[6],
        name: 'Care Activities Performed Today',
        type: 't9wW',
        archived: false,
        options: ["Fertilized","Added Soil","Trimmed/Pruned","Rotated Pot","Pest Control","Applied Support"],
        required: false,
    },{
        id: ids[7],
        name: 'Care Notes',
        type: 'fLZw',
        archived: false,
        options: [],
        required: false,
    },{
        id: ids[8],
        name: 'Signs of Pests',
        type: 'Q44D',
        archived: false,
        options: [],
        required: false,
    },{
        id: ids[9],
        name: 'Signs of Disease',
        type: 'Q44D',
        archived: false,
        options: [],
        required: false,
    },{
        id: ids[10],
        name: 'Issue Notes',
        type: 'fLZw',
        archived: false,
        options: [],
        required: false,
    },{
        id: ids[11],
        name: 'Harvest Yield Today',
        type: 'BaPx',
        archived: false,
        options: [],
        required: false,
    },{
        id: ids[12],
        name: 'Progress Photo',
        type: 'tR9m',
        archived: false,
        options: [],
        required: false,
    },];
};

const contactForm = () => {
    const ids = getIds(5);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[0],
        name: 'Contact Form',
        type: 'G7kP',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[1],
        name: 'First Name',
        type: 'flqW',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[2],
        name: 'Last Name',
        type: 'flqW',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[3],
        name: 'Email',
        type: 'pP4n',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[4],
        name: 'Phone Number',
        type: 'Z1yK',
        archived: false,
        options: [],
        required: false
    }, {
        id: 'address-field',
        name: 'Address',
        type: 'tC8M',
        archived: false,
        options: [],
        required: false
    }];
};

const liquidPoster = () => {
    const ids = getIds(10);
    return [{
        id: 'date',
        name: 'Timestamp',
        type: 'date',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[0],
        name: {
            header: 'Vehicle For Sale',
            paragraph: 'Replace the sample details below with your vehicle information and upload up to 5 photos.'
        },
        type: 'H8ep',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[1],
        name: 'Photos',
        type: 'poster-carousel',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[2],
        name: '',
        type: 'Xb72',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[3],
        name: {
            header: 'Make',
            paragraph: 'Toyota'
        },
        type: 'H8ep',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[4],
        name: {
            header: 'Model',
            paragraph: 'Camry SE'
        },
        type: 'H8ep',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[5],
        name: {
            header: 'Year',
            paragraph: '2020'
        },
        type: 'H8ep',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[6],
        name: {
            header: 'Mileage',
            paragraph: '48,250'
        },
        type: 'H8ep',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[7],
        name: {
            header: 'Price',
            paragraph: '$18,900'
        },
        type: 'H8ep',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[8],
        name: {
            header: 'Phone',
            paragraph: '(555) 555-5555'
        },
        type: 'H8ep',
        archived: false,
        options: [],
        required: false
    }, {
        id: ids[9],
        name: {
            header: 'Email',
            paragraph: 'you@example.com'
        },
        type: 'H8ep',
        archived: false,
        options: [],
        required: false
    }];
};

export const trackerDefaults = {
    'bug-report': bugReport(),
    'maintenance-tracker': maintenanceTracker(),
    'review': review(),
    'service-log': serviceLog(),
    'vehicle-log': vehicleLog(),
    'workout-log': workoutLog(),
    'garden-label': gardenLabel(),
    'contact-form': contactForm(),
    'liquid-poster': liquidPoster(),
    'for-sale': [],
};
